module.exports = __webpack_public_path__ + "static/media/usage_clothes.054b4ed9.png";